// extracted by mini-css-extract-plugin
export default {"shimmer":"styles_shimmer__tOiaB","shimmerMove":"styles_shimmerMove__-Q8Hn"};